import { query } from 'src/boot/axios';

// eslint-disable-next-line import/prefer-default-export
export class Factory {
    constructor (app) {
        this.app = app;
    }

    // eslint-disable-next-line class-methods-use-this
    async loadPage (uuid) {
        let page;
        await query(`select * from pages where uuid = '${uuid}' limit 1`).then((r) => {
            // eslint-disable-next-line prefer-destructuring
            page = r.data[0];
        });
        return page;
    }

    // eslint-disable-next-line class-methods-use-this
    async loadViews (uuid) {
        const components = [];
        await query(`select * from views where parent_uuid = '${uuid}' order by view_index`).then((r) => {
            r.data.forEach((c) => {
                if (c.params === '') { c.params = undefined; }
                const params = JSON.parse(c.params ?? '{}');
                const component = {
                    id: c.id,
                    uuid: c.uuid,
                    name: c.type.charAt(0).toUpperCase() + c.type.slice(1),
                    params,
                    options: c.options,
                };
                components.push(component);
            });
        });
        return components;
    }

    // eslint-disable-next-line class-methods-use-this
    getPageAuthor (uuid) {
        return new Promise((resolve, reject) => {
            query(`select author from pages where uuid = '${uuid}' limit 1`).then((r) => {
                resolve(r.data[0]);
            }).catch((e) => {
                reject(e);
                console.error(e);
            });
        });
    }
}
